import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Vue from "vue";
Vue.filter("filterDate", function (value, fmt) {
  if (!value) return "-";
  var date = new Date(value);

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  var o = {
    "M+": date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1,
    "d+": date.getDate() < 10 ? "0" + date.getDate() : date.getDate(),
    "h+": date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
    "m+": date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
    "s+": date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + "";
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : str);
    }
  }

  return fmt;
});
Vue.filter("getWeek", function (value) {
  if (!value) return "-";
  var date = new Date(value);
  var num = date.getDay();
  var week = "星期";

  switch (num) {
    case 0:
      week += "日";
      break;

    case 1:
      week += "一";
      break;

    case 2:
      week += "二";
      break;

    case 3:
      week += "三";
      break;

    case 4:
      week += "四";
      break;

    case 5:
      week += "五";
      break;

    case 6:
      week += "六";
      break;

    default:
      break;
  }

  return week;
});
Vue.filter("costTime", function (value) {
  if (!value) return "-";
  var time = Math.floor(value / 1000);
  var day = Math.floor(time / (3600 * 24));
  var hour = Math.floor((time - day * 3600 * 24) / 3600);
  var minute = Math.floor((time - day * 3600 * 24 - hour * 3600) / 60);
  var second = Math.floor(time - day * 3600 * 24 - hour * 3600 - minute * 60);
  var str = "";

  if (day > 0) {
    str += day + "天";
  }

  if (hour > 0) {
    str += hour + "时";
  }

  if (minute > 0) {
    str += minute + "分";
  }

  str += second + "秒";
  return str;
}); // 将global中的数组转换成filter过滤器渲染

Vue.filter("global", function (value, arr) {
  var _iterator = _createForOfIteratorHelper(arr),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;

      if (item.value == value) {
        return item.label;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return "";
}); // 获取一段0-1，a-z，A-Z的随机数

Vue.filter("roll", function (max, tabStr, tabNum) {
  // max: 长度, tabStr: 间隔符, tabNum: 间隔值（每隔几个该值的字符插入一个间隔符）
  var rollArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "r", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  var str = "",
      tab = 0;

  for (var i = 0; i < max; i++) {
    var key = parseInt(Math.random() * rollArr.length, 10);
    str += rollArr[key];
    tab++;

    if (tabStr && tab == tabNum) {
      str += "-";
      tab = 0;
    }
  }

  if (tabStr && tabNum) {
    str = str.substring(0, str.length - 1);
  }

  return str;
});